import React, { useState } from "react";
import "./HRCopilotNewsSection.css";
import NewsDetailsModal from "./NewsDetailsModal";


export default function HRCopilotNewsSection() {
  const [selectedPost, setSelectedPost] = useState(null);
  const posts = [
    {
      id: 1,
      category1: "ONBOARDING",
    //   category2: "WORKFLOWS",
      title: "Automated Employee Onboarding",
      date: "1",
    //   month: "JAN",
      desc:
        "Humanex streamlines onboarding with automated document collection, workflow tracking, and personalized employee journeys.",
      img: "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/img-blog-29-1280x1280.jpg",
    },
    {
      id: 2,
    //   category1: "HIRING",
      category2: "AI MATCHING",
      title: "AI-Powered Candidate Screening",
      date: "2",
    //   month: "FEB",
      desc:
        "Reduce hiring time with AI-driven talent matching that analyzes profiles, skills, and job fit instantly.",
      img: "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/img-blog-01-1280x1280.jpg",
    },
    {
      id: 3,
      category1: "HR AUTOMATION",
    //   category2: "PRODUCTIVITY",
      title: "Smart Workflow Automation",
      date: "3",
    //   month: "FEB",
      desc:
        "Let Humanex take care of repetitive HR tasks — from verification to reminders — so teams can focus on engagement.",
      img: "https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/img-blog-23-1280x1280.jpg",
    },
];

return (
  <>
    <NewsDetailsModal
      post={selectedPost}
      onClose={() => setSelectedPost(null)}
    />
    <div className="news-section">

      {/* ⭐ SECTION TITLE */}
      <div className="news-heading">
        <h1 className="news-main-title">Latest Insights & <span>Updates</span> </h1>
        <p className="news-subtitle">
          Stay updated with the latest Humanex features, workflows, and automation enhancements.
        </p>
      </div>

      {/* NEWS CARDS */}
      <div className="news-wrapper">
        {posts.map((post) => (
          <div className="news-card" key={post.id}>

            <div className="news-img-box">
              <img src={post.img} alt={post.title} className="news-img" />
              <div className="gradient-overlay"></div>

              <div className="news-date-badge">
                <span className="date-num">{post.date}</span>
                <span className="date-month">{post.month || ''}</span>
              </div>
            </div>

            <div className="news-content-box">
              <div className="news-tags">
                <span>{post.category1}</span>
                <span>{post.category2}</span>
              </div>

              <h2 className="news-title">{post.title}</h2>
              <p className="news-desc">{post.desc}</p>

           <button
              className="news-read-btn"
              onClick={() => setSelectedPost(post)}
            >
              Read more <span>›</span>
            </button>

            </div>

          </div>
        ))}
      </div>
    </div>
  </>
  );
}
